/**
 * AnalyticsPublic
 * 存储localStorage交换数据
 */
export default {
  timeFlag: 0,
  lang: 'zh-CN',

  productid: null,
  productname: null,
  registertime: null,
  authorized: false,
  watchshow: 0,

  platform: [],
  platformFull: [],

  selectedDate: [],
  qualitySelectedDate: [],
  conditions: {
    partner: [],
    usergroup: [],
    version: [],
    newUserGroup: [],
  },
};